import http from '@/communication/AuthConnection'

/**
* Read the file dropped
*/
const readFile = ({ form }) => {
  const formData = new FormData()
  formData.append('client', form.client)

  if (form.alternativeCode) { formData.append('alternativeCode', form.alternativeCode) }
  if (form.identification) { formData.append('identification', form.identification) }
  if (form.eventObject) { formData.append('eventObject', form.eventObject) }
  if (form.sourcePortal) { formData.append('sourcePortal', form.sourcePortal) }
  if (form.estimated) { formData.append('estimated', form.estimated) }
  if (form.countItems) { formData.append('countItems', form.countItems) }
  if (form.dateEvent) { formData.append('dateEvent', form.dateEvent) }
  if (form.dateDeadline) { formData.append('dateDeadline', form.dateDeadline) }
  if (form.modality) { formData.append('modality', form.modality) }

  return http
    .post('/v1/event/bid-capture', formData, {
      headers: {
        'Content-type': 'multipart/form-data'
      }
    })
}

export default readFile



// WEBPACK FOOTER //
// ./src/components/event/bid-capture/SaveNewEvent.js